import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({
	name: 'moment',
})
export class MomentPipe implements PipeTransform {
	transform(
		value: moment.Moment | Date | number,
		format: string,
		timeZone?: string,
		locale?: string
	): any {
		if (!value) {
			return '-';
		}

		const dateTime = timeZone ? moment.tz(value, timeZone) : moment(value);
		dateTime.locale(locale);

		return dateTime.format(format);
	}
}
